function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Cloud"
}, /*#__PURE__*/React.createElement("path", {
  d: "M397.8,123.1H397A123.72,123.72,0,0,0,273.3,0H236.7A123.72,123.72,0,0,0,113,123.1h-2A111,111,0,0,0,0,234.1H0a111,111,0,0,0,111,111H397.8a111,111,0,0,0,111-111h0C508.9,172.8,459.1,123.1,397.8,123.1Z",
  fill: "red",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Offline"
}, /*#__PURE__*/React.createElement("path", {
  d: "M232,84.1l11.6,133.2h21.5L276.7,84.1s0-23.7-22.4-23.7S232,84.1,232,84.1Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 254.4,
  cy: 258.1,
  r: 26.6,
  fill: "#fff"
}));

var SvgCloud = function SvgCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508.8,
    height: 345.1,
    viewBox: "0 0 508.8 345.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud.21dc53d1.svg";
export { ForwardRef as ReactComponent };